import { Injectable, inject } from '@angular/core';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { LocalStorageService } from '@app/core/local-storage/local-storage.service';

import {
  SETTINGS_KEY,
  SettingsActionTypes,
  ActionSettingsPersist
} from '@app/core/settings/settings.reducer';

@Injectable()
export class SettingsEffects {
  private actions$ = inject<Actions<Action>>(Actions);
  private localStorage = inject(LocalStorageService);


  persistSettings = createEffect(() =>
    this.actions$.pipe(
      ofType(SettingsActionTypes.PERSIST),
      tap((action: ActionSettingsPersist) =>
        this.localStorage.setItem(
          SETTINGS_KEY,
          action.payload.settings
        )
      )
    ),
    { dispatch: false }
  );
}
